import React, { PropTypes } from 'react';

import './styles.scss';

function setOptions(props) {
  const options = props.placeholder ? ([
    { name: props.placeholder, value: '' },
    ...props.options,
  ]) : (
    props.options
  );

  return [
    ...options,
  ];
}

export const Dropdown = props => (
  <div className={`dropdown ${props.className}`}>
    <label>
      {props.name}
    </label>
    <select
      onChange={event => props.onChange(event)}
      disabled={props.disabled}
    >
      {
        setOptions(props).map(option => (
          <option key={option.value} value={option.value}>
            {option.name}
          </option>
        ))
      }
    </select>
  </div>
);

Dropdown.propTypes = {
  onChange: PropTypes.func,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes.array,
  name: PropTypes.string,
  disabled: PropTypes.bool,
};


export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/shared/dropdown/main.jsx